import React from "react";
import { Button, NewTab, PageTab } from "../../../components";
import { useNavigate } from "react-router-dom";
import ChecklistSettings from "./Checklist/ChecklistSettings";


const CheckList = () => {
  // const[checkListType,setCheckListType] = useState("Applicant");
  const navigate = useNavigate();
  const CheckListMenus = [
    {
      title: "Applicants",
      page: <ChecklistSettings checkListType={1} />,
      type: "main",
    },
    {
      title: "Vendors",
      page: <ChecklistSettings checkListType={2} />,
      type: "main",
    },
    {
      title:"Client",
      page: <ChecklistSettings checkListType={3} />,
      type:"main",
    }
    // {
    //   title: "Settings",
    //   link: "",
    //   type: "sub",
    //   icon: "settings",
    //   variant: "text",
    // },
    // {
    //   title: "Settings",
    //   page: <EOnboardingSettings />,
    //   type: "sub",
    //   icon: "settings",
    //   align: 'right',
    // },
  ];
  return (
    <div className="flex flex-col gap-3">
      <Button
        title={"Back"}
        icon={"west"}
        variant="text"
        color="black"
        className="!self-start font-semibold !px-1"
        onClick={() => navigate("/e-onboarding#dashboard")}
      />
      <NewTab
        tabs={CheckListMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="checklist"
      />
    </div>
  );
};

export default CheckList;
